<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import dateMixin from '../../mixins/dateMixin';
import escapable from '../../mixins/escapable';

export default {
  name: 'TriggerRulesSettingsLogs',
  mixins: [
    dateMixin,
    escapable,
  ],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterType: 'all',
      pagination: {
        rowsPerPage: -1,
        descending: true,
      },
    };
  },
  computed: {
    ...mapState({
      logs: state => state.triggers.rules.settings.logs,
    }),
    ...mapGetters({
      headers: 'triggers/getSettingsLogsHeaders',
      actions: 'triggers/getSettingActionTypes',
    }),
    computedLogs() {
      return this.logs.items.filter((log) => {
        if (this.filterType === 'all') {
          return true;
        }
        return this.filterType === log.action;
      });
    },
  },
  methods: {
    ...mapActions({
      getLogs: 'triggers/getLogs',
    }),
    close() {
      this.$emit('close');
    },
    escapeHandler() {
      this.close();
    },
    getColor(log) {
      return this.actions[log.action].color;
    },
  },
  created() {
    this.getLogs(this.item.id);
  },
};
</script>

<template>
  <v-dialog
    :value="true"
    max-width="800px"
    persistent
    no-click-animation
  >
    <v-card>
      <v-card-title>
        <h3>
          Change log for: {{ item.name }}
        </h3>
        <v-spacer/>
        <v-btn class="ma-0" icon small><v-icon @click="close">close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-layout row align-center>
          <v-flex xs6>
            <v-select v-model="filterType" :items="Object.values(actions)" label="Action Type" hide-details/>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider/>
      <v-card-text class="trigger-rules-settings-logs__card">
        <v-layout row>
          <v-flex xs12>
            <v-data-table
              :items="computedLogs"
              :loading="logs.loading"
              :headers="headers"
              :pagination.sync="pagination"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.user.firstName }} {{ props.item.user.lastName }}</td>
                  <td>{{ formatDate(props.item.createdAt) }}</td>
                  <td :class="getColor(props.item)" class="text-capitalize">{{ props.item.action }}</td>
                  <td class="text-xs-center">
                    <v-tooltip v-if="props.item.comment" right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">comment</v-icon>
                      </template>
                      <span>{{ props.item.comment }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-slot:no-results>
                <span v-if="logs.loading" class="grey--text font-italic">Loading logs...</span>
                <span v-else>No logs found</span>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.trigger-rules-settings-logs {
  &__card {
    max-height: 600px;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Triggers/TriggerRulesSettingsLogs.vue